import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response && err.response.status === 401) {
      if (window.location.pathname.startsWith("/admin") && window.location.pathname !== "/admin") {
        window.location.href = "/admin";
      }
    }
    return Promise.reject(err);
  }
);

// Resolve any stored image reference to a full URL
export const imageUrl = (ref) => {
  if (!ref) return "";
  if (ref.startsWith("http") || ref.startsWith("data:")) return ref;
  if (ref.startsWith("/api")) return `${BACKEND_URL}${ref}`;
  return `${API}/images/${ref}`;
};

export default api;
